/* eslint no-console: 0 */

/**
 * If on debug mode, add a global function which displays the number
 * bindings
 */
angular.module('debug')
    .run(['$window', ($window) => {

        if (CWCONFIG.features.debug) {

            $window.countBindings = () => {

                const $ = angular.element;
                const root = $(document.getElementsByTagName('body'));
                const watchers = [];

                const f = (element) => {

                    const data = element.data();
                    if (_.has(data, ('$scope'))) {

                        angular.forEach(data.$scope.$$watchers, (watcher) => {

                            watchers.push(watcher);

                        });

                    }

                    angular.forEach(element.children(), (childElement) => {

                        f($(childElement));

                    });

                };

                f(root);
                console.log(`${watchers.length} bindings`);

            };

        }

    }]);



// WEBPACK FOOTER //
// ./scripts/common/modules/debug.js